import { render, staticRenderFns } from "./ErrorNotice.vue?vue&type=template&id=26e2f5ab&"
import script from "./ErrorNotice.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports